module.exports = __webpack_public_path__ + "static/media/Pechugas de pollo a la parrilla.aecb0a2b.webp";